function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 342 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154605",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.328-862.78a22.311 22.311 0 0 0 4.446-4.58 7.439 7.439 0 0 0 1.5-4.134 6.076 6.076 0 0 0-1.666-4.4 5.691 5.691 0 0 0-4.283-1.725 5.691 5.691 0 0 0-4.283 1.725 6.076 6.076 0 0 0-1.666 4.4 7.439 7.439 0 0 0 1.5 4.134 22.31 22.31 0 0 0 4.452 4.58zm0 3a27.93 27.93 0 0 1-6.26-6.008 9.886 9.886 0 0 1-2.067-5.71 8.421 8.421 0 0 1 2.32-6.112 7.994 7.994 0 0 1 6.007-2.39 8 8 0 0 1 6.008 2.394 8.421 8.421 0 0 1 2.32 6.112 9.886 9.886 0 0 1-2.067 5.71 27.931 27.931 0 0 1-6.261 6.008zm0-9.517a2.291 2.291 0 0 0 1.68-.7 2.291 2.291 0 0 0 .7-1.68 2.291 2.291 0 0 0-.7-1.68 2.291 2.291 0 0 0-1.68-.7 2.291 2.291 0 0 0-1.68.7 2.291 2.291 0 0 0-.7 1.68 2.291 2.291 0 0 0 .7 1.68 2.291 2.291 0 0 0 1.68.704zM200-856.207v-2.379h16.655v2.379zm8.328-15.465z",
    transform: "translate(-196.328 880)",
    style: {
      fill: "#121212"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/spot.2eec959bf8206c1a932954b0ac0a1997.svg";
export { ForwardRef as ReactComponent };